module.exports = __webpack_public_path__ + "img/option_woocommerce.5c19ab3d.svg";